// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scrollbar Customization */
.RCA-table-holder::-webkit-scrollbar {
  height: 10px;
  /* Height of horizontal scrollbar */
  background-color: grey;
  /* Background color of the scrollbar track */
  width: 10px;
  border-radius: 10px;
}

.RCA-table-holder::-webkit-scrollbar-corner {
  background-color: #1D1D1D;
}

.RCA-table-holder::-webkit-scrollbar-thumb {
  background-color: rgb(55, 55, 55);
  /* Color of the scrollbar thumb */
  border-radius: 10px;
  border: 2px solid grey;
}

/* Scrollable Container */
.RCA-table-holder {
  overflow: auto;
  /* Enable scrolling */
  max-height: 60.5vh;
  /* Set a maximum height for the container */
  width: 100%;
  /* Responsive width */
}

/* Table Styles */
table {
  width: 100%;
  /* Table spans the full width */
  table-layout: auto;
  /* Columns adjust based on content */
  border-collapse: collapse;
  /* Cleaner border appearance */
}

/* Header and Cell Styles */
th,
td {
  text-align: left;
  font-size: 14px;
  white-space: nowrap;
  /* Prevent text wrapping */
  overflow: hidden;
  /* Hide overflowed content */
  text-overflow: ellipsis;
  /* Add ellipsis for overflowed text */
  padding: 8px;
  /* Add spacing */
  border: 1px solid var(--primary-border, #616161);
  /* Consistent borders */
}

/* Optional Text Wrapping for Specific Columns */
td.wrap-text {
  white-space: normal;
  /* Allow text wrapping */
  word-wrap: break-word;
  /* Break long words */
}

/* Dropdown Button */
.dropDownButton {
  color: #3387DF;
  font-size: 14px;
  /* Match table font size */
  font-weight: bold;
  border: 1px solid #3387DF;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  /* Balanced padding */
  border-radius: 50px;
  margin-right: 10px;
}

.write-back-button {
  color: white;
  font-size: 16px;
  font-weight: 400;
  font-weight: bold;
  background-color: #3387DF;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 30px;
  padding-right: 30px;
  border-radius: 50px;
}

.write-back-button :hover {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/RootCauseAnalysis/RcaTable.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,YAAY;EACZ,mCAAmC;EACnC,sBAAsB;EACtB,4CAA4C;EAC5C,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,2CAA2C;EAC3C,WAAW;EACX,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;;EAEE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;EACvB,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;EAChB,gDAAgD;EAChD,uBAAuB;AACzB;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* Scrollbar Customization */\n.RCA-table-holder::-webkit-scrollbar {\n  height: 10px;\n  /* Height of horizontal scrollbar */\n  background-color: grey;\n  /* Background color of the scrollbar track */\n  width: 10px;\n  border-radius: 10px;\n}\n\n.RCA-table-holder::-webkit-scrollbar-corner {\n  background-color: #1D1D1D;\n}\n\n.RCA-table-holder::-webkit-scrollbar-thumb {\n  background-color: rgb(55, 55, 55);\n  /* Color of the scrollbar thumb */\n  border-radius: 10px;\n  border: 2px solid grey;\n}\n\n/* Scrollable Container */\n.RCA-table-holder {\n  overflow: auto;\n  /* Enable scrolling */\n  max-height: 60.5vh;\n  /* Set a maximum height for the container */\n  width: 100%;\n  /* Responsive width */\n}\n\n/* Table Styles */\ntable {\n  width: 100%;\n  /* Table spans the full width */\n  table-layout: auto;\n  /* Columns adjust based on content */\n  border-collapse: collapse;\n  /* Cleaner border appearance */\n}\n\n/* Header and Cell Styles */\nth,\ntd {\n  text-align: left;\n  font-size: 14px;\n  white-space: nowrap;\n  /* Prevent text wrapping */\n  overflow: hidden;\n  /* Hide overflowed content */\n  text-overflow: ellipsis;\n  /* Add ellipsis for overflowed text */\n  padding: 8px;\n  /* Add spacing */\n  border: 1px solid var(--primary-border, #616161);\n  /* Consistent borders */\n}\n\n/* Optional Text Wrapping for Specific Columns */\ntd.wrap-text {\n  white-space: normal;\n  /* Allow text wrapping */\n  word-wrap: break-word;\n  /* Break long words */\n}\n\n/* Dropdown Button */\n.dropDownButton {\n  color: #3387DF;\n  font-size: 14px;\n  /* Match table font size */\n  font-weight: bold;\n  border: 1px solid #3387DF;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 16px;\n  /* Balanced padding */\n  border-radius: 50px;\n  margin-right: 10px;\n}\n\n.write-back-button {\n  color: white;\n  font-size: 16px;\n  font-weight: 400;\n  font-weight: bold;\n  background-color: #3387DF;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-left: 30px;\n  padding-right: 30px;\n  border-radius: 50px;\n}\n\n.write-back-button :hover {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
